module.exports = __webpack_public_path__ + "assets/media/Marketing Video.fdc9159e.mp4";